import api from "@/api.js";

export default {
  state: {
    users: {},
    usersLoading: false
  },
  mutations: {
    setUsers(state, payload) {
      state.users = payload;
    },
    setUsersLoading(state, payload) {
      state.usersLoading = payload;
    }
  },
  actions: {
    async loadUsers({ commit }) {
      commit("setUsersLoading", true);
      let users = await api.get("users");
      commit("setUsers", users.data);
      commit("setUsersLoading", false);
    },
    async newUser({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("users", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      dispatch("loadUsers");
      return returnData;
    },
    async saveUser({ dispatch }, payload) {
      let returnData = {};
      await api
        .put(`users`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      dispatch("loadUsers");
      return returnData;
    },
    async linkUserLocation({ dispatch }, payload) {
      let returnData = {};
      await api
        .post(`users/linkToLocation`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      dispatch("loadUsers");
      return returnData;
    },
    async unlinkUserLocation({ dispatch }, payload) {
      let returnData = {};
      await api
        .post(`users/unlinkToLocation`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      dispatch("loadUsers");
      return returnData;
    },
    async resetUserTempPassword({ dispatch }, payload) {
      api.post(`users/resetTempPassword`, payload);
    }
  },
  getters: {
    users(state) {
      return state.users;
    },
    usersLoading(state) {
      return state.usersLoading;
    }
  }
};
